// extracted by mini-css-extract-plugin
export default {"inputError":"G6e957f"};